import { ExclamationCircleIcon } from '@heroicons/react/20/solid'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

const I18N = 'mail_template.edit_mail_template.issues.'

// Probleme, die das Speichern sperren. Der Container steht immer im DOM, damit
// Screenreader neue Meldungen über aria-live ansagen. Der Editor verweist per
// aria-describedby hierher.
const MailTemplateIssues = ({ id, issues }) => {
  const { t } = useTranslation()

  return (
    <div id={id} role='status' aria-live='polite'>
      {issues.length > 0 && (
        <ul className='mt-3 space-y-1.5'>
          {issues.map(({ code, location, token, snippet }) => (
            <li
              key={[location, code, token || snippet].join(':')}
              className='flex gap-x-2 text-sm text-red-700'
            >
              <ExclamationCircleIcon
                aria-hidden='true'
                className='mt-0.5 h-4 w-4 flex-none text-red-500'
              />
              <span>
                {t(
                  `${I18N}${location === 'subject' ? 'subject_' : ''}${code}`,
                  {
                    token: token || snippet
                  }
                )}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

MailTemplateIssues.propTypes = {
  id: PropTypes.string.isRequired,
  issues: PropTypes.array.isRequired
}

export default MailTemplateIssues
